import React, { Fragment, useEffect, useState } from 'react';
import { useSnackbars } from '../../hooks/snackbar.hook';
import { getPageContent, toPageContentDTO } from '../../services/page.service';
import { showAxiosMessageError } from '../../services/error-message.service';
import { PageContentDto } from '../../services/dtos/page-content.dto';
import InformationUi from '../../components/user-interfaces/footer/information.ui';
import { Button, Grid, Typography } from '@mui/material';
import { resetCookieConsentValue } from 'react-cookie-consent';
import { useNavigate } from 'react-router-dom';

/**
 * Composant de la page RGPD, cgu, notice
 * Les données de la page sont récupérées via l'API
 * @constructor
 */
export default function InformationPage(props: { page: string }) {
    //Permet de savoir si on est passé une fois dans le useEffect
    const showMessage = useSnackbars();

    const [loading, setLoading] = useState<boolean>(true);

    // Navigation
    const navigate = useNavigate();

    const [pageContent, setPageContent] = useState<PageContentDto>({
        title: '',
        content: '',
        image: undefined,
    });

    // Récupère les données du back permettant de construire la page
    useEffect(() => {
        let isMounted = true;
        setLoading(true);
        //Récupération des contenus
        getPageContent(props.page)
            .then(async result => {
                if (result && result.length > 0) {
                    isMounted && setPageContent(await toPageContentDTO(result));
                } else {
                    setPageContent({
                        title: 'Page vide',
                        content: "Aucune donnée n'a été récupérée",
                        image: undefined,
                    });
                }
            })
            .catch(error => {
                console.error('Erreur lors de la récupération du contenu de la page');
                showAxiosMessageError(error, showMessage);
            })
            .finally(() => {
                setLoading(false);
            });

        //unamount
        return () => {
            isMounted = false;
        };

        //https://stackoverflow.com/questions/55840294/how-to-fix-missing-dependency-warning-when-using-useeffect-react-hook
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.page]);

    // Suppression des cookies
    const clearCookies = () => {
        resetCookieConsentValue('acceptGoogle');
        navigate(0);
    };

    return (
        <Fragment>
            <InformationUi params={pageContent} loading={loading} />
            {props.page === 'gestioncookies' && (
                <Grid container spacing={2} sx={{ marginTop: '20px' }}>
                    <Grid item xs={12} md={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Typography variant={'button'}>
                            <Button variant={'contained'} onClick={clearCookies} style={{ width: '100%' }}>
                                Réinitialiser les cookies
                            </Button>
                        </Typography>
                    </Grid>
                </Grid>
            )}
        </Fragment>
    );
}
